module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "team-member-list-container"
  }, [_c('h3', {
    staticClass: "title is-3"
  }, [_vm._v("Team Members")]), _vm._v(" "), _c('input', {
    staticClass: "button",
    class: {
      'is-active': _vm.editing
    },
    attrs: {
      "type": "button",
      "value": "edit"
    },
    on: {
      "click": function($event) {
        _vm.$emit('editing')
      }
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "team-list"
  }, _vm._l((_vm.team.members), function(member) {
    return (_vm.team.members.length > 0) ? _c('li', {
      staticClass: "flex-space-between panel-block"
    }, [_vm._v("\n\n      " + _vm._s(member.name || member.email) + " "), (member.is_coach) ? _c('span', {
      staticClass: "tag is-rounded is-primary"
    }, [_vm._v("Coach")]) : _vm._e(), (member.is_group_admin) ? _c('span', {
      staticClass: "tag is-rounded is-warning"
    }, [_vm._v("Admin")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('input', {
      staticClass: "button is-small is-danger",
      attrs: {
        "type": "button",
        "value": "remove",
        "name": "remove"
      },
      on: {
        "click": function($event) {
          _vm.removeUser(_vm.team.id, member.id)
        }
      }
    }) : _vm._e()]) : _vm._e()
  })), _vm._v(" "), (_vm.team.members.length === 0 && _vm.team.expanded) ? _c('p', [_vm._v("\n    No members in this team.\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-398c4a52"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeamMemberList.vue
// module id = 1007
// module chunks = 0